/**
 * Created by dmitry on 29.07.2025
 */

const RewardMultiplierWindow = CleverappsWindow.extend({
    ctor: function (params) {
        this.rewardList = new RewardsList(params.reward);
        this.onBought = params.onBought;
        this.onCanceled = params.onCanceled;

        this._super();
    },

    onWindowLoaded: function () {
        this._super({
            title: this.getBgBundle() === undefined && Messages.get("RewardMultiplierWindow.title"),
            name: "RewardMultiplierWindow",
            content: this.createContent(),
            noBackground: true,
            closeButton: false
        });

        cleverapps.metrics.logEvent(`${cleverapps.EVENTS.UNITS_SHOP_ITEM}_x2_open`);
        cleverapps.playSession.logEventOnce(`${cleverapps.EVENTS.UNITS_SHOP_ITEM}_x2_open_dau`);
    },

    getBgBundle: function () {
        const frame = cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL
            ? "bg_vertical_json"
            : "bg_horizontal_json";

        return bundles.reward_multiplier_window && bundles.reward_multiplier_window.jsons[frame];
    },

    createContent: function () {
        const styles = cleverapps.styles.RewardMultiplierWindow;
        
        const json = this.getBgBundle();

        if (!json) {
            const rewardList = this.createRewardsList();
            const buttonsBox = this.createButtonsBox();
            return new cleverapps.Layout([rewardList, buttonsBox], {
                padding: styles.padding,
                direction: cleverapps.UI.VERTICAL,
                margin: styles.margin
            });
        }

        const bg = this.bg = new cleverapps.Spine(json);

        this.createTitle();
        this.createRewardsList();
        this.createReceiveButton();
        this.createMultiplyButton();

        return bg;
    },

    onShow: function () {
        this._super();

        if (!this.bg) {
            return;
        }

        this.bg.setAnimationAndIdleAfter("open", "idle");

        this.rewardView.setVisible(false);

        this.rewardView.setVisible(false);
        this.runAction(new cc.Sequence(
            new cc.DelayTime(this.bg.getAnimationDuration("open") * 0.5),
            new cc.CallFunc(() => {
                this.rewardView.setVisible(true);
                this.rewardView.showUp(this.delayedShowUp.bind(this), {
                    source: this.bg.getSlot("slot_reward_source")
                });
            })
        ));
    },

    createTitle: function () {
        const slot = this.bg.getSlot("slot_title");

        const text = cleverapps.UI.generateOnlyText(
            Messages.get("RewardMultiplierWindow.title"),
            cleverapps.styles.FONTS.REWARD_MULTIPLIER_WINDOW_TITLE
        );
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        text.fitTo(slot.width);
        text.setAlignment({
            x: { align: "center" },
            y: { align: "center" }
        });

        slot.addChild(text);
    },

    createRewardsList: function () {
        const styles = cleverapps.styles.RewardMultiplierWindow.rewardsList;

        if (!this.bg) {
            return new RewardsListComponent(this.rewardList, {
                font: cleverapps.styles.FONTS.REWARD_MULTIPLIER_WINDOW_VALUE_TEXT,
                iconWrap: styles.iconWrap,
                margin: styles.margin,
                textMargin: styles.textMargin,
                shine: true,
                columns: 3,
                fitToBox: styles.fitToBox[cleverapps.resolution.mode],
                filterCustomAnimation: true
            });
        }

        const slot = this.bg.getSlot("slot_reward");
        const rewardListView = this.rewardView = new RewardsListComponent(this.rewardList, {
            small: true,
            columns: this.rewardList.rewards.length,
            textPosition: styles.textPosition,
            filterCustomAnimation: true
        });

        rewardListView.setAlignment({
            x: { align: "center" },
            y: { align: "center" }
        });
        slot.addChild(rewardListView);
    },

    createButtonsBox: function () {
        const styles = cleverapps.styles.RewardMultiplierWindow.buttonsBox;

        return new cleverapps.Layout([this.createReceiveButton(), this.createMultiplyButton()], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin
        });
    },

    createReceiveButton: function () {
        const styles = this.bg ? cleverapps.styles.RewardMultiplierWindow.receiveButton : cleverapps.styles.RewardMultiplierWindow.button;

        const button = new cleverapps.UI.Button({
            type: cleverapps.styles.UI.Button.Images.button_blue,
            text: Messages.get("RewardMultiplierWindow.ReceiveButton"),
            onClicked: () => {
                cleverapps.metrics.logEvent(`${cleverapps.EVENTS.UNITS_SHOP_ITEM}_x2_free`);

                this.buyParams = {};
                this.close();
            },
            width: styles.width,
            height: styles.height
        });

        if (!this.bg) {
            return button;
        }

        const slot = this.bg.getSlot("slot_continue_button");

        button.setAlignment({
            x: { align: "center" },
            y: { align: "center" }
        });

        slot.addChild(button);
    },

    createMultiplyButton: function () {
        const styles = this.bg ? cleverapps.styles.RewardMultiplierWindow.multiplyButton : cleverapps.styles.RewardMultiplierWindow.button;

        const onClicked = () => {
            cleverapps.rewardedAdsManager.playRewarded(
                AdsLimits.TYPES.FREEX2,
                () => {
                    cleverapps.metrics.logEvent(`${cleverapps.EVENTS.UNITS_SHOP_ITEM}_x2_ads`);

                    this.buyParams = { videoBonus: true };
                    if (!this.closed) {
                        this.close();
                    }
                },
                () => {
                    cleverapps.metrics.logEvent(`${cleverapps.EVENTS.UNITS_SHOP_ITEM}_x2_cancel`);

                    if (!this.closed) {
                        this.close();
                    }
                }
            );
        };

        if (!this.bg) {
            return new cleverapps.UI.Button({
                type: cleverapps.styles.UI.Button.Images.button_green,
                text: `${Messages.get("RewardMultiplierWindow.MultiplyButton")} ##`,
                onClicked,
                width: styles.width,
                height: styles.height
            });
        }

        const buttonText = cleverapps.UI.generateOnlyText(
            Messages.get("RewardMultiplierWindow.MultiplyButton"),
            cleverapps.styles.FONTS.REWARD_MULTIPLIER_WINDOW_MULTIPLY_BUTTON_TEXT
        );
        const adIcon = new cc.Sprite(bundles.reward_multiplier_window.frames.multiplier_add_icon_png);
        const adIconBox = new cc.Node();
        adIconBox.setAnchorPoint(0.5, 0.5);
        adIconBox.setContentSize(adIcon.width, buttonText.height);
        adIconBox.addChild(adIcon);
        adIcon.setAlignment(styles.adIcon);

        const buttonContent = new cleverapps.Layout([buttonText, adIconBox], {
            direction: cleverapps.UI.HORIZONTAL
        });

        const button = new cleverapps.UI.Button({
            type: cleverapps.styles.UI.Button.Images.button_green,
            content: buttonContent,
            onClicked,
            width: styles.width,
            height: styles.height,
            scale9Rect: cleverapps.UI.Scale9Rect.TwoPixelXY
        });

        const slot = this.bg.getSlot("slot_x2_button");

        button.setAlignment({
            x: { align: "center" },
            y: { align: "center" }
        });

        slot.addChild(button);
    },

    beforeCloseAnimation: function (callback) {
        if (!this.bg) {
            callback();
            return;
        }

        this.rewardView.setVisible(false);

        this.runAction(new cc.Spawn(
            new cc.DelayTime(1),
            new cc.CallFunc(() => {
                this.bg.stopAllActions();
                this.bg.setAnimation(0, "close");
            })
        )).setFinalize(callback);
    },

    onClose: function () {
        if (this.buyParams) {
            this.onBought(this.buyParams);
        } else {
            this.onCanceled();
        }
    },

    listBundles: function () {
        return ["reward_multiplier_window", ...this.rewardList.listBundles()];
    }
});

RewardMultiplierWindow.isAvailable = function (product) {
    return product.videoBonus
        && cleverapps.adsLimits.state(AdsLimits.TYPES.FREEX2) === AdsLimits.STATE_READY;
};

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    REWARD_MULTIPLIER_WINDOW_MULTIPLY_BUTTON_TEXT: {
        size: 70,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_3PX
    },

    REWARD_MULTIPLIER_WINDOW_TITLE: {
        size: 110,
        lineHeight: 110,
        color: new cc.Color(255, 223, 75, 255),
        stroke: {
            color: new cc.Color(178, 81, 0, 255),
            size: 4
        }
    },

    REWARD_MULTIPLIER_WINDOW_VALUE_TEXT: {
        size: 56,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    }
});

cleverapps.styles.RewardMultiplierWindow = {
    margin: 60,
    padding: {
        top: 70,
        bottom: 70
    },

    rewardsList: {
        iconWrap: {
            height: 130
        },

        margin: {
            x: 130,
            y: 70
        },

        fitToBox: [
            { width: 650, height: 650 },
            { width: 900, height: 650 },
            { width: 900, height: 650 }
        ],

        textMargin: 0,

        textPosition: {
            x: { align: "right", dx: 5 },
            y: { align: "bottom", dy: -10 }
        }
    },

    buttonsBox: {
        margin: 40
    },

    button: {
        width: 320,
        height: 110
    },

    multiplyButton: {
        width: 400,
        height: 120,

        adIcon: {
            x: { align: "right" },
            y: { align: "bottom", dy: 10 }
        }
    },

    receiveButton: {
        width: 280,
        height: 90
    }
};
